var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_405_55",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9048 0H2.09524C0.93807 0 0 0.955126 0 2.13333V13.8667C0 15.0449 0.93807 16 2.09524 16H19.9048C21.0619 16 22 15.0449 22 13.8667V2.13333C22 0.955126 21.0619 0 19.9048 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_405_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9048 0H2.09524C0.93807 0 0 0.955126 0 2.13333V13.8667C0 15.0449 0.93807 16 2.09524 16H19.9048C21.0619 16 22 15.0449 22 13.8667V2.13333C22 0.955126 21.0619 0 19.9048 0Z",
    fill: "#CD0B20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.26666H22V11.7333H0V4.26666Z",
    fill: "#FFCB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42857 6.6368V9.3248C9.42857 10.0715 8.72457 10.6688 7.85714 10.6688H5.7619C4.89657 10.6667 4.19048 10.0661 4.19048 9.32267V6.63467C4.19048 6.02454 4.65981 5.51467 5.30514 5.34934C5.5 4.79467 6.09924 5.29174 6.80952 5.29174C7.524 5.29174 8.11905 4.79787 8.3139 5.3504C8.95714 5.52 9.42857 6.03094 9.42857 6.6368Z",
    fill: "#C8B47C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42857 7.46666H10.4762V10.6667H9.42857V7.46666ZM3.14286 7.46666H4.19048V10.6667H3.14286V7.46666Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42857 9.60001H10.4762V10.6667H9.42857V9.60001ZM3.14286 9.60001H4.19048V10.6667H3.14286V9.60001Z",
    fill: "#165C96"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42857 6.39999H10.4762V7.46666H9.42857V6.39999ZM3.14286 6.39999H4.19048V7.46666H3.14286V6.39999Z",
    fill: "#A0790A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23809 6.39999H6.28571V7.99999H5.23809V6.39999ZM7.33333 8.53333H8.38095V10.1333H7.33333V8.53333Z",
    fill: "#D20636"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 6.39999H8.38095V7.99999H7.33333V6.39999Z",
    fill: "#A18793"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23809 8.53334H6.28571V10.1333H5.23809V8.53334Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28571 6.39999L5.23809 5.33333H8.38095L7.33333 6.39999H6.28571Z",
    fill: "#B6161A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28571 4.26666H7.33333V5.33333H6.28571V4.26666Z",
    fill: "#AC9300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9048 0.53334H2.09524C1.22736 0.53334 0.523811 1.24968 0.523811 2.13334V13.8667C0.523811 14.7503 1.22736 15.4667 2.09524 15.4667H19.9048C20.7726 15.4667 21.4762 14.7503 21.4762 13.8667V2.13334C21.4762 1.24968 20.7726 0.53334 19.9048 0.53334Z",
    stroke: "black",
    strokeOpacity: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/ES.38f5f66fabf0532e5131f2ee97911881.svg";
export { ForwardRef as ReactComponent };